import {createI18n} from 'vue-i18n';
import {getLocale} from '@hit/components/src/plugins/i18n/i18n';
import {mergeLocaleMessages, messagesFromGlob} from '../../../../i18n-glob.js';

const europeDateFormat = {
  longSeconds: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  short: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
};

const datetimeFormats = {
  'fr-BE': europeDateFormat,
  'nl-BE': europeDateFormat,
  'de-BE': europeDateFormat,
  'en-GB': europeDateFormat,
};

function loadLocaleMessages() {
  const messages = messagesFromGlob(
    import.meta.glob('../locales/**/*.json', {eager: true})
  );

  mergeLocaleMessages(messages, loadComponentsLocaleMessages());

  return messages;
}

function loadComponentsLocaleMessages() {
  return messagesFromGlob(
    import.meta.glob('../../../hit-components/src/locales/**/*.json', {
      eager: true,
    })
  );
}

export const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: {
    fr: ['fr-BE'],
    de: ['de-BE'],
    nl: ['nl-BE'],
    en: ['en-GB'],
    default: ['en-GB'],
  },
  datetimeFormats: datetimeFormats,
  messages: loadLocaleMessages(),
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
});

export const translate = (key) => {
  if (!key) {
    return '';
  }
  return i18n.global.t(key);
};

export const translatec = (key) => {
  if (!key) {
    return '';
  }
  return i18n.global.tc(key);
};

export default function installVueI18N(app) {
  app.use(i18n);
}
